// extracted by mini-css-extract-plugin
export default {"logo":"LinkedinCard_logo__ABYcp"};